export enum PointsApplicationMethod {
    SET_TO = "setTo",
    INCREMENT_BY = "incrementBy",
    DECREMENT_BY = "decrementBy"
}